import { render, staticRenderFns } from "./FormatTextComponent.vue?vue&type=template&id=10ab4d87&scoped=true&"
import script from "./FormatTextComponent.vue?vue&type=script&lang=ts&"
export * from "./FormatTextComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ab4d87",
  null
  
)

export default component.exports